window.addEventListener('load', function() {
    const mealItemManageEl = document.querySelector('.mealitems-manage');
    if (mealItemManageEl) {
        const MealItemsManager = require('../modules/MealItemsManager');
        var mod = new MealItemsManager(mealItemManageEl, {});
    }

    const mealItemFormEl = document.querySelector('.mealitems-form');
    if (mealItemFormEl) {
        const MealItemsForm = require('../modules/MealItemsForm');
        var mod = new MealItemsForm(mealItemFormEl, {});
    }
});